import { render, staticRenderFns } from "./TelegramSearchOrder.vue?vue&type=template&id=455d0814&"
import script from "./TelegramSearchOrder.vue?vue&type=script&lang=ts&"
export * from "./TelegramSearchOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TelegramSearchOrder.vue"
export default component.exports